module.exports = __webpack_public_path__ + "static/media/travel.b49aa66c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/travel.svg
// module id = 175
// module chunks = 0